/*
 * @Author: Merlin
 * @Date: 2025-05-21 10:27:13
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-29 16:20:44
 * @Description: 文件名以 02 开头，优先级多半已经足够，将来按需改为 00 提升加载顺序 
 */
import 'regenerator-runtime/runtime';

export default defineNuxtPlugin((nuxtApp) => {

    // 这是 Array.prototype.at() 的 Polyfill 用于防止在旧版本浏览器上无法使用  
    if (!Array.prototype.at) {
        Array.prototype.at = function(index) {
            const len = this.length;
            if (index < 0) {
                index = len + index;
            }
            return (
                index >= 0 && index < len
                ? this[index]
                : void 0
            );
        };
    }

    if (!Array.prototype.findLast)  {
        Array.prototype.findLast  = function(callback, thisArg) {
            if (typeof callback !== 'function') {
                throw new TypeError('Callback must be a function');
            }
            
            for (let i = this.length  - 1; i >= 0; i--) {
                if (i in this && callback.call(thisArg,  this[i], i, this)) {
                    return this[i];
                }
            }
            return undefined;
        };
    }

    if (typeof Promise.withResolvers !== 'function') {
        Promise.withResolvers = function() {
            let resolve, reject;
            const promise = new Promise((res, rej) => {
                resolve = res;
                reject = rej;
            });
            return { promise, resolve, reject };
        } as any;
    }

    if (import.meta.client) {
        // 兼容低版本浏览器 Element.prototype.getAttributeNames
        if (!Element.prototype.getAttributeNames) {
        Element.prototype.getAttributeNames = function (): string[] {
            const attrs = this.attributes;
            const names: string[] = [];
            for (let i = 0; i < attrs.length; i++) {
            names.push(attrs[i].name);
            }
            return names;
        };
        }
    }
    
    if (true){
        // 四舍五“不”入
        // 示例 (1.9999999).beFixed(2) 得出： 1.99 
        // 示例 (1.9999999).beFixed(0) 得出： 1 
        Number.prototype['beFixed'] = function(
            iPrecision=0, // 默认0与 toFixed 行为一致  
        ) {
            // 参数验证与精度处理（与原生toFixed保持一致）
            let prec = Math.max(
                0,
                Math.floor(iPrecision),
            ); 
            if (prec > 100) prec = 100;
            return getFixed(
                this.valueOf(),
                prec,
            );
        };
        /* 测试案例（粘贴到控制台运行）
            [
                [1.555, 2],       // 正数四舍五不入 -> "1.55"
                [-1.555, 2],      // 负数截断 -> "-1.55"
                [9.9999, 3],      // 尾部连续9截断 -> "9.999"
                // 边界值测试 
                [0.0001, 4],      // 微小值测试 -> "0.000"
                [Number.MAX_SAFE_INTEGER, 2], // 超大整数 -> "9007199254740991.00"
                // 特殊数值场景 
                [NaN, 2],         // 非法数值 -> "NaN"
                [Infinity, 0],    // 无穷大 -> "Infinity"
                // 精度参数特性 
                [2.71828, 3.5],   // 非整数精度（自动取整到3） -> "2.718"
                [3.1415, -1],     // 非法精度抛出RangeError
            ].forEach(aThisOne => {
                const [num, param] = aThisOne;
                console.log(
                    num, `保留小 ${param} 位小数 --->`, num.beFixed(param)
                );
            }); 
        */
    }

    // ↓ 此值表示用户浏览器比服务器“快” 了多少毫秒；
    // ↓ 浏览器时间 - 服务器时间的时间差 = 结果值  
    // ↓ 在服务器侧值为0 
    let iAheadMS = import.meta.server ? 0 : null;

    /**
     * 用于代替 Date.now() 以取得更准确的时间 
     * @returns Number
     */
    Date['Now'] = ()=>{
        if (iAheadMS === null){
            // 一定要使用三等号，以确保只会进入到此一次，并同时确保只在浏览器侧调用 
            iAheadMS = getTimeGapMS() || 0;
        }
        // ↓ 容差毫秒数；两者时差小于 X 毫秒，视用户浏览器与服务器时间一致（按需调整）
        const iTolerance = 2_000;

        // ↓ 没有时差信息 || 时差在容差内，直接返回浏览器时间 
        if (!iAheadMS || (Math.abs(iAheadMS) < iTolerance)){
            return Date.now();
        }
        if (1 && import.meta.env.DEV_MODE){
            console.log('实测浏览器时间领先真实值：', (iAheadMS/1_000).toFixed(1), 's_现已校准 💎');
        }
        // ↓ 此值通常是正数，因为服务器时间信息需要“耗时”发到用户浏览器，固应小于浏览器时间 
        if (iAheadMS < 0){
            // 那么如果此值为负数，说明用户浏览器比服务器还慢，严重失真；返回的值 + 慢的毫秒数 
            return Date.now() + Math.abs(iAheadMS);
        }

        // ↓ 本地比服务器快太多了，减去多出来的毫秒数 
        return Date.now() - iAheadMS;
    }

    /**
     * 用于替代 new Date()，以取得更准确的时间对象 
     * @returns 
     */
    Date['getReal'] = ()=>{
        const ts = Date['Now']();
        return new Date(ts);
    }
});

/**
 * 查询浏览器和服务器的时间差 
 * @returns Number
 */
function getTimeGapMS(){
    try {
        const xhr = new XMLHttpRequest();
        xhr.open(
            'HEAD',
            location.origin + location.pathname,
            false, // 同步
        );
        xhr.send(null);
        const sDate = xhr.getResponseHeader('Date');
        if (sDate) {
            const oDate = new Date(sDate);
            return Date.now() - oDate.getTime();
        }else{
            return 0; // 不得已认定服务器与本地无时差 
        }
    } catch (err) {
        console.warn('查询 SSTS 出错', err);
        return 0;
    }
}
